"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.8 25",
    width: "20.8",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3,25H0.5C0.2,25,0,24.8,0,24.5v-24C0,0.2,0.2,0,0.5,0h13.6c0.1,0,0.3,0.1,0.4,0.1l6.3,6.3c0.1,0.1,0.1,0.2,0.1,0.4 v17.7C20.8,24.8,20.6,25,20.3,25z M1,24h18.8V7l-6-6H1V24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.3,7.3h-6.3c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v5.8h5.8c0.3,0,0.5,0.2,0.5,0.5 S20.6,7.3,20.3,7.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.8,20c-0.3,0-0.5-0.2-0.5-0.5v-5.4c0-0.3,0.2-0.5,0.5-0.5h2.4c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-1.9v4.9 C15.3,19.8,15.1,20,14.8,20z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6,17.3h-1.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h1.7c0.3,0,0.5,0.2,0.5,0.5S16.8,17.3,16.6,17.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4,20h-1C9.2,20,9,19.8,9,19.5v-5.4c0-0.3,0.2-0.5,0.5-0.5h1c1.4,0,2.3,1.3,2.3,3.2S11.8,20,10.4,20z M10,19h0.5 c1,0,1.3-1.2,1.3-2.2c0-1-0.4-2.2-1.3-2.2H10V19z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.4,20c-0.3,0-0.5-0.2-0.5-0.5v-5.4c0-0.3,0.2-0.5,0.5-0.5h1.3c1.2,0,1.8,0.6,1.8,1.9s-0.6,1.9-1.8,1.9H4.9v2.2 C4.9,19.8,4.7,20,4.4,20z M4.9,16.3h0.8c0.7,0,0.8-0.2,0.8-0.9c0-0.6-0.1-0.9-0.8-0.9H4.9V16.3z"
  }));
};

exports["default"] = _default;